@for (reaction of filteredReactions; track reaction) {
    <app-reaction-icon
        [isShowReactionCount]="isShowReactionCount"
        [isSingleEmoji]="isSingleEmoji"
        [reaction]="reaction"
        [tooltipTextType]="tooltipTextType">
    </app-reaction-icon>
}
@if (isShowTotalCount) {
    <span class="text-light ms-1 vertical-align-middle">{{ reactionsCount }}</span>
}
